import { useState, useEffect } from "react";

const Counter = ({ endValue, duration = 4000, pauseTime = 40000 }) => {
  const [count, setCount] = useState(0);
  const [isResetting, setIsResetting] = useState(false);

  useEffect(() => {
    let start = 0;
    const increment = endValue / (duration / 50); // Incremento baseado no tempo total

    const runCounter = () => {
      const timer = setInterval(() => {
        start += increment;
        if (start >= endValue) {
          clearInterval(timer);
          setCount(endValue); // Garante o valor final correto
          setIsResetting(true); // Indica que está no período de pausa

          // Reinicia o contador após a pausa
          setTimeout(() => {
            setCount(0); // Reseta o contador
            setIsResetting(false); // Sai do estado de pausa
            start = 0; // Reseta o valor inicial
            runCounter(); // Inicia o ciclo novamente
          }, pauseTime);
        } else {
          setCount(Math.floor(start)); // Atualiza com números inteiros
        }
      }, 50);
    };

    runCounter(); // Inicia o contador

    return () => clearInterval(runCounter); // Cleanup do intervalo
  }, [endValue, duration, pauseTime]);

  return <>{isResetting ? endValue : count}</>; // Exibe o valor final durante a pausa
};

export default Counter;
